import httpClient from '@/http-client'

export const get = (options = {}) => {
	return httpClient
		.get('/api/teaching-calendars', options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const update = data => {
	return httpClient
		.put(`/api/teaching-calendars/${data.id}`, data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const staff = data => {
	return httpClient
		.get('/api/teaching-calendars/staffs', data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export default { get, update, staff }
